import styled from "styled-components";

import { colors } from "const/colors";
import { plusFeatures } from "const/content";
import { Article, Section, SectionLarge, Text } from "styles";

import StoreBadges from "../StoreBadges/StoreBadges";

const Frame = styled.div`
	width: 100%;
	background: #fff;
	border-radius: 32px;
	overflow: hidden;
	box-sizing: border-box;
	box-shadow: 0 12px 40px rgba(96, 48, 160, 0.08);

	@media (max-width: 600px) {
		border-radius: 24px;
	}
`;

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 16px;
	width: 100%;

	@media (max-width: 800px) {
		grid-template-columns: 1fr;
	}
`;

const Card = styled.div`
	background: ${colors.page};
	border-radius: 20px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
`;

const CardBody = styled.div`
	padding: 24px;
`;

const CardImage = styled.img`
	width: 100%;
	max-height: 220px;
	object-fit: contain;
	background: #111;
`;

const Pad = styled.div`
	padding: 0 50px 12px;
	width: 100%;
	box-sizing: border-box;

	@media (max-width: 600px) {
		padding: 0 25px 12px;
	}
`;

const Badges = styled.div`
	margin-top: 8px;
`;

export default function PlusHighlights() {
	return (
		<Section>
			<SectionLarge style={{ width: "100%", flexDirection: "column" }}>
				<Frame>
					<Article style={{ paddingBottom: 8 }}>
						<Text midExtreme>
							<Text color={colors.purple}>Wishbox+</Text>
							<Text color={colors.blue}> costs less</Text> than a single unnecessary purchase and{" "}
							<Text color={colors.magenta}>helps you find those</Text> every month.
						</Text>
						<Text lede style={{ display: "block", marginTop: 20, maxWidth: 720 }}>
							Unlock collaboration, the assistant, richer widgets, currencies, cloud sync, export,
							and backups when you are ready. No commitment — cancel anytime.
						</Text>
						<Badges>
							<StoreBadges />
						</Badges>
					</Article>
					<Pad>
						<Grid>
							{plusFeatures.map(feature => (
								<Card key={feature.title}>
									{feature.image && <CardImage src={feature.image} alt="" />}
									<CardBody>
										<Text
											header
											style={{
												display: "block",
												marginBottom: 10,
												fontSize: 28,
												lineHeight: "32px"
											}}
										>
											{feature.title}
										</Text>
										<Text body>{feature.description}</Text>
									</CardBody>
								</Card>
							))}
						</Grid>
						<Badges>
							<StoreBadges />
						</Badges>
					</Pad>
				</Frame>
			</SectionLarge>
		</Section>
	);
}
